import * as THREE from 'three';

export class WebGLAssets {
  
  static parallaxMeshes: THREE.Mesh[] = [];
  static toolImageCount: number = 0;
  static toolCurrentLayer: number = 0;
  static layerController: {
    activeLayer: number
    activeImageUrl: string
  } = {
    activeLayer: 0,
    activeImageUrl: ''
  };
}